import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import AppWrapper from '../app_wrapper';
import AboutUsMobile from '../components_mobile/pages/AboutUs';
import AboutUsDesktop from '../components_desktop/pages/AboutUs';
import { apiGet } from '../modules/api';
import metadata from '../helpers/metadataHelper';

const AboutUsComponent = props => (
  <Fragment>
    <AppWrapper
      desktopComp={<AboutUsDesktop {...props} />}
      mobileComp={<AboutUsMobile {...props} />}
      metadata={metadata.aboutUs}
    />
  </Fragment>
);

AboutUsComponent.getInitialProps = ({ store, req, res }) => store.dispatch(apiGet('api/home', req, res));

const mapStateToProps = () => ({});

const AboutUs = connect(mapStateToProps)(AboutUsComponent);
export default AboutUs;
